import topProgress from './top-progress/'
import topBar from './top-bar/'
import topTabs from './top-tabs/'
import topBanner from './top-banner/'
import topHeader from './top-header/'

import blockingDialog from './blocking-dialog/'
import blockingSearch from './blocking-search/'
import blockingMenu from './blocking-menu/'
import blockingDrawer from './blocking-drawer/'
import blockingProgression from './blocking-progression/'

import bottomShortcut from './bottom-shortcut/'
import bottomSnackbar from './bottom-snackbar/'
import bottomAction from './bottom-action/'
import bottomNavigation from './bottom-navigation/'

export default () => {
  const page = ({
    topProgress: topProgress(),
    topBar: topBar(),
    topTabs: topTabs(),
    topBanner: topBanner(),
    topHeader: topHeader(),

    blockingDialog: blockingDialog(),
    blockingSearch: blockingSearch(),
    blockingMenu: blockingMenu(),
    blockingDrawer: blockingDrawer(),
    blockingProgression: blockingProgression(),

    bottomShortcut: bottomShortcut(),
    bottomSnackbar: bottomSnackbar(),
    bottomAction: bottomAction(),
    bottomNavigation: bottomNavigation()
  })

  return {
    ...page,
    confirm: ({ title, content, callback, action1 }) => {
      page.blockingDialog.set({
        title,
        content,
        action1: action1 ? {
          onClick: async () => {
            await action1.onClick()
            page.blockingDialog.unset()
          },
          label: action1.label
        } : {
          label: `Valider`,
          onClick: async () => {
            await callback()
            page.blockingDialog.unset()
          }
        },
        action2: {
          label: `Annuler`,
          onClick: () => {
            page.blockingDialog.unset()
          }
        }
      })
    }
  }
}
